import React, { Component, useState } from 'react';
import { Navbar } from 'reactstrap';
import Profile from './Profile';
import './Header.css';
import { useEffect } from 'react';
import HeaderBackgroundImage from '../../images/header-background.jpg';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

const Header = ({ handleWizardFarmChanged }) => {

    const [defaultFarmName, setDefaultFarmName] = useState();
    const [defaultFarmUniqueId, setDefaultFarmUniqueId] = useState();
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    useEffect(() => {
        setDefaultFarmName(JSON.parse(localStorage.getItem("defaultFarmName")))
        setDefaultFarmUniqueId(JSON.parse(localStorage.getItem("defaultFarmUniqueId")))
    })

    const handleSetFarm = async (id) => {
        const farmId = parseInt(id);
        try {
            const response = await axios.get(
                '/api/settings/getFarmDetail/', {
                params: { farmId: farmId, userId: userId }
            }
            );
            localStorage.setItem("defaultFarmId", JSON.stringify(id));
            localStorage.setItem("defaultFarmName", JSON.stringify(response.data.name));
            localStorage.setItem("defaultFarmUniqueId", JSON.stringify(response.data.uniqueIdentifier));
            handleWizardFarmChanged(farmId);
        } catch (err) {
            if (err?.response) {
                toast.error("No server response");
            }
        }
    }

    const handleClick = async (e) => {
        e.preventDefault(); // Prevents the default anchor behavior (e.g., navigation)
        try {
            const response = await axios.get(
                '/api/settings/GetUsers/', {
                params: {}
            }
            );
            if (response.data != null) {
                var user = response.data.content.users.filter(x => x.id == userId);
                if (user[0].userFarmList.length == 1) {
                    await handleSetFarm(user[0].userFarmList[0].id);
                }
                else if (user[0].userFarmList.length > 0) {
                    window.open("/allfarmssummary", "_self");
                }
                else {
                    toast.error("Sorry, this user does not have any farm allocated to access. Please contact admin team", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow" container light style={{
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                }}>
                    <div className="logo-farm-name">
                        <div className="header-logo">
                            {/*<a href="javascript:void(0);"><img className="logo" src="/images/fwfp-logo.png" /></a>*/}
                           {/* <img className="logo" src="/images/fwfp-logo.png" />*/}
                        </div>
                        {defaultFarmUniqueId != undefined && defaultFarmUniqueId != null && 
                            <div className="farm-detail" style={{ marginLeft: "25vw", width: "15vw", borderRadius: "12px" }}>
                                <span className="farm-name"><a href="/" onClick={handleClick}>{defaultFarmName}</a></span>
                                <span className="farm-unique-id">Unique ID: {defaultFarmUniqueId}</span>
                            </div>    
                        }
                    </div>
                    <Profile />
                </Navbar>
                </header>
        </>
    );
}


export default Header
